// extracted by mini-css-extract-plugin
module.exports = {"boxes":"organizationBrand_boxes__3rN1u","save":"organizationBrand_save__1tHZx","saveButton":"organizationBrand_saveButton__2t80r"};